const ImageTypes = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif'
]
const AcceptedTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ...ImageTypes
]

const isDownloadable = (type) => ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(type)

export { ImageTypes, AcceptedTypes, isDownloadable}


// WEBPACK FOOTER //
// ./src/utils/attachmentTypes.js